<template>
    <div class="benefits flex column no-overflow">
        <div class="be-content-item be-pg">
            <img :src="require('../../assets/Desktop/About_Us/01-img.svg')" alt="page 1">
        </div>
        <div class="be-content-item be-title-cont">
            <h1 class="be-title">The Benefits</h1>
        </div>
        <div class="be-content-item be-content-container">
            <div class="be-cont-wrap md-container">
                <h1 class="be-subtitle">Private Customer</h1>
                <p class="be-content-text"><strong>Convenience</strong> - Our innovative technology allows the customer to easily plan a family vacation; a night out on the town; an exclusive private party; an exclusive stay at a private location, or an anniversary dinner with a significant other all at the tip of your fingers with ease</p>
                <p class="be-content-text"><strong>Efficiency</strong> – Using this app allows the user to have more time doing other activities because they wont have to make the numerous phone calls that it takes to schedule a successful event</p>
            </div>
            <div class="be-img-wrap">
                <img class="md-container" :src="require('../../assets/Desktop/About_Us/pc_img.png')" alt="Private Customer">
                <img class="mobile-img" :src="require('../../assets/Mobile/Mobile_About_Us/PC_IMG.png')" alt="Private Customer">
            </div>
            <div class="be-cont-wrap mobile-content">
                <h1 class="be-subtitle">Private Customer</h1>
                <p class="be-content-text"><strong>Convenience</strong> - Our innovative technology allows the customer to easily plan a family vacation; a night out on the town; an exclusive private party; an exclusive stay at a private location, or an anniversary dinner with a significant other all at the tip of your fingers with ease</p>
                <p class="be-content-text"><strong>Efficiency</strong> – Using this app allows the user to have more time doing other activities because they wont have to make the numerous phone calls that it takes to schedule a successful event</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
            }
        }
    }
</script>

<style scoped>
    @media (max-width: 880px) {
        .benefits {
            height: 1150px !important;
        }

        .be-content-container {
            justify-content: center !important;
            flex-direction: column !important;
            text-align: center !important;
        }

        .mobile-img {
            height: auto !important;
            width: 90vw !important;
            display: block !important;
            margin: auto !important;
        }

        .be-content-text {
            width: 80vw !important;
            color: #333333;
            font-family: Trirong;
            font-size: 16px;
            letter-spacing: 1px;
            margin: auto;
        }

        .be-subtitle {
            color: #BF9E47;
            font-family: Trirong;
            font-size: 32px;
            font-weight: 800;
        }

        .be-cont-wrap {
            margin: 0!important;
        }

        .mobile-content {
            display:block!important;
        }
    }

    .mobile-img, .mobile-content {
        display: none;
    }

    .benefits {
        height: 870px;
    }

    .be-content-item {
        text-align: center;
    }

    .be-content-container {
        justify-content: center;
        display: flex;
        flex-direction: row;
        text-align: left;
    }

    .be-title {
        color: #333333;
        font-family: Trirong;
        font-size: 32px;
        font-weight: 800;
    }

    .be-content-text {
        width: 512px;
        color: #333333;
        font-family: Trirong;
        font-size: 16px;
        letter-spacing: 1px;
    }

    .be-subtitle {
        color: #BF9E47;
        font-family: Trirong;
        font-size: 32px;
        font-weight: 800;
    }

    .be-cont-wrap {
        margin: 25px 130px 0 180px;
    }

    .be-pg {
        margin: 100px 0 0 0;
    }

    .be-title-cont {
        margin: 0 0 35px 0;
    }

    .be-img-wrap {
        margin: -12px 0 0 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/about/Benefits.vue